export const NPS_TRACK_SUBMITTED = 'jora-employer/nps/TRACK_SUBMITTED';
export const NPS_TRACK_REASON = 'jora-employer/nps/TRACK_REASON';
